/* Canadian French */

export default {
  "Selected": "Sélectionné",
  "Clear": "Effacer",
  "Search": "Rechercher",
  "No results found": "Aucun résultat trouvé",
  'Date-range': 'Date-gamme',
  Date: 'Date',
  'Add Another': 'Ajouter un autre',
  "Select up to": "Sélectionnez jusqu'à",
  "days": "jours",
  "Recent": "Récent",
  "Search Entities": "Rechercher des Entités",
  "Try searching for an entity’s name, or ID. You can also search for a location.": "Essayez de rechercher le nom ou l’ID d’une entité. Vous pouvez également rechercher un lieu.",
  "Your recent search history will be shown here the next time you use search.": "L’historique de vos recherches récentes sera affiché ici la prochaine fois que vous utiliserez la fonction de recherche.",
  "l": "l",
  "gal": "gal",
  "L/100KM": "L/100Â KM",
  "MPG": "MPG",
  "KM/L": "KM/L",
  "kph": "km/h",
  "mph": "mi/h",
  "kph/s": "kph/s",
  "mph/s": "mph/s",
  "m": "m",
  "ft": "pi",
  "kg": "kg",
  "lbs": "lbs",
  "°C": "°C",
  "°F": "°F",
  "square meters": "mètres carrés",
  "square feet": "pieds carrés",
  "square kilometers": "kilomètres carrés",
  "square miles": "miles carrés",
  "kPa": "kPa",
  "psi": "psi",
  "tonne": "tonne",
  "ton": "ton",
  "km": "km",
  "mi": "mi",
  "just now": "À l'instant",
  "now": "maintenant",
  "ago": "il y a",
  "yesterday at": "TBD",
  "weeks": "semaines",
  "hours": "Heures",
  "minutes": "minutes",
  "seconds": "TBD",
  "week": "semaine",
  "day": "jour",
  "hour": "Heure",
  "minute": "minute",
  "second": "seconde",
  "wk": "TBD",
  "hr": "TBD",
  "min": "min",
  "sec": "TBD",
  "Enter at least 2 characters to search": "Entrez au moins 2 caractères pour rechercher",
  "Keyword": "Mot-clé",
  "Show by type": "Afficher par type",
  "Find": "Trouver",
  "by": "par",
  "Try searching for": "Essayez de rechercher",
  "Try searching by keyword.": "Essayez de rechercher par mot-clé.",
  "No matches found": "Aucune correspondance trouvée",
  "Enter atleast two characters to search": "Entrez au moins deux caractères pour rechercher",
  "Group results": "Regrouper les résultats",
  "Filter for": "Filtrer pour",
  "More": "Plus",
  "more": "plus",
  "Drag and drop images & documents": "Glissez et déposez des images et documents",
  "Upload": "Téléverser",
  "Upload failed": "Échec de l'envoi",
  "Uploads failed": "Téléchargements échoués",
  "Uploaded files have the following issues:": "Les fichiers téléversés présentent les problèmes suivants :",
  "File exceeds": "Taille du fichier dépasse",
  "limit": "limite",
  "is not supported. Please upload": "n'est pas pris en charge. Veuillez télécharger",
  "File is empty or corrupted.": "Le fichier est vide ou corrompu.",
  "Network error": "Erreur réseau",
  "Invalid format or size.": "Format ou taille invalide.",
  "Supported formats:": "Formats pris en charge:",
  "File Size:": "Taille du fichier:",
  "MB Max": "Mo Maximum",
  "of": "de",
  "uploaded": "téléchargé",
  "file": "fichier",
  "files": "fichiers",
  "out of": "sur",
  "Retry": "Réessayer",
  "Fetch Failed": "Échec du chargement",
  "B": "o",
  "KB": "Ko",
  "MB": "Mo",
  "GB": "Go",
  "Please upload a document": "Veuillez télécharger un document",
  "An error occurred with this file.": "Une erreur s'est produite avec ce fichier.",
  "Item": "Élément",
  "image": "image",
  "You can only upload up to": "Vous ne pouvez télécharger que jusqu'à",
  "and": "et",
  "or": "ou",
  "Unknown format": "Format inconnu",
  "Please enter numeric values": "Veuillez saisir des valeurs numeriques",
  "Date format": "Format de date",
  "Please select a date after": "Veuillez selectionner une date apres",
  "Please select a date before": "Veuillez selectionner une date avant",
  "Please select a date between": "Veuillez selectionner une date entre",
  "Please select a valid date": "Veuillez selectionner une date valide",
  "Please enter a valid date": "Veuillez saisir une date valide",
  "Write something...": "Écrivez quelque chose...",
  "Esc to": "Échap pour",
  "Cancel": "Annuler",
  "Enter": "Entrée",
  "to": "pour",
  "Save": "Sauvegarder",
  "Show Filters": "Afficher les filtres",
  "Hide Filters": "Masquer les filtres",
  "Show deactivated entities": "Afficher les entités désactivées",
  "Show deactivated": "Afficher les désactivés",
  "Deactivated": "Désactivé",
  "No data available": "Aucune donnée disponible",
  "Image not available": "Image non disponible",
  "Video not available": "Vidéo non disponible",
  "Customize Columns": "Personnaliser les colonnes",
  "Drag to reorder. Toggle visibility with the eye icon.": "Faites glisser pour réorganiser. Basculez la visibilité avec l'icône en forme d'œil.",
  "Apply": "Appliquer",
  "results": "résultats",
  "Table pagination": "Pagination du tableau",
  "Previous page": "Page précédente",
  "Next page": "Page suivante",
  "Press < for quick navigation": "Appuyez sur < pour une navigation rapide",
  "Press > for quick navigation": "Appuyez sur > pour une navigation rapide",
  "Last updated:": "Dernière mise à jour :",
}
